import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogContent,  
  Stack,
  Box,
  Divider,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useSigner, useContract } from "wagmi";
import SessionContext from "../contexts/session";
import { useTranslation, Trans } from "react-i18next";
import VerifiedIcon from "@mui/icons-material/Verified";
import { getPendingRewards,getVestedRewards } from "../models/n2wcalls";

export default function RewardModal() {
  const { account, selectedNetwork } = useContext(SessionContext);
  const { data: signer } = useSigner({ chainId: selectedNetwork.chainIdDec });
  const [pendingN2W, setPendingN2W] = useState(0);
  const [vestedN2W, setVestedN2W] = useState(0);
  const n2wContract = useContract({
    address: selectedNetwork.contract.address,
    abi: selectedNetwork.contract.abi,
    signerOrProvider: signer,
  });
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let isMounted = true; // Flag to track component mount status

    const fetchData = async () => {
      const pendingRewards = await getPendingRewards(
        account,
      );
      const vestedRewards = await getVestedRewards(
        account,
      );

      if (isMounted) {
        setPendingN2W(parseFloat(pendingRewards));
        setVestedN2W(parseFloat(vestedRewards));
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Cleanup to prevent state updates on unmounted component
    };
  }, [account, n2wContract, selectedNetwork.version]);

  return (
    <div>
      <Alert
        severity="warning"
        action={
          <Button onClick={handleClickOpen} variant="contained">
            <Trans t={t}>Check Rewards</Trans>
          </Button>
        }
      >
        <AlertTitle>
          <Trans t={t}>Earn $N2W</Trans>
        </AlertTitle>
        <Trans t={t}>
          Accumulate $N2W on every bet, even before the token launch.
        </Trans>
      </Alert>
      <N2WCard
        open={open}
        onClose={handleClose}
        pendingN2W={pendingN2W}
        vestedN2W={vestedN2W}
      />
    </div>
  );
}

function N2WCard(props) {
  const { t } = useTranslation();
  const { onClose, open, pendingN2W, vestedN2W } = props;
  //setError setSuccess
  const [error] = useState("");
  const [success] = useState("");
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>      
      <DialogContent>
        <Stack spacing={4}>
          <Alert severity="warning" icon={<VerifiedIcon color="warning" />}>
            <AlertTitle>
              <Trans t={t}>$N2W Contract not deployed</Trans>
            </AlertTitle>
            <p>
              <Trans t={t}>
                The $N2W token is not available yet, you won't be able to claim your tokens yet
              </Trans>
            </p>
          </Alert>
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="h6"><Trans t={t}>Pending $N2W Rewards</Trans></Typography>
              <Typography
                variant="h4"
                sx={{ marginTop: 1, marginBottom: 0 }}
                //sx={{ textAlign: "center" }}
              >
                {pendingN2W}
              </Typography>
              <Box
                sx={{ display: "flex", justifyContent: "center", marginTop: 1 }}
              >
                <Button variant="contained" disabled sx={{ opacity: 0.5 }}>
                  Vest
                </Button>
              </Box>
            </Box>
            <Divider orientation="vertical" sx={{ marginX: 2 }} />
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="h6"><Trans t={t}>Vested $N2W</Trans></Typography>
              <Typography
                variant="h4"
                sx={{ marginTop: 1, marginBottom: 0 }}
                //sx={{ textAlign: "center" }}
              >
                {vestedN2W}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  disabled
                  sx={{ opacity: 0.5, marginRight: 1, flex: 1 }}
                >
                  <Trans t={t}>Claim unlocked</Trans>
                </Button>
                <Button
                  variant="contained"
                  disabled
                  sx={{ opacity: 0.5, flex: 1 }}
                >
                  <Trans t={t}>Claim all</Trans>
                </Button>
              </Box>
            </Box>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
